import Editor from "~/js/editor";
import { $div } from "~/js/utilities/TurboDom";
import { recalculateTextAreaHeight } from "~/solidJs/shared/helpers";
import { onNextFrame } from "~/solidJs/shared/helpers/promiseHelpers";
import { initTextViewerHoverMenu } from "~/solidJs/widgets/HoverFeatureMenu";
import Viewer from "../viewer";

export default class textViewer extends Viewer {
	static type = "description";
	static supportedExtensions = ["text", "description", "description"];
	constructor(asset, socketsOutput = null, socketName = null) {
		super(asset, socketsOutput, socketName);
		if (socketsOutput.optionalInfo.additionalLabel) {
			this.initAddintionalLabel();
		}

		// Initialize new hover feature menu
		if (socketsOutput && socketName) {
			this.hoverMenuCleanup = initTextViewerHoverMenu(this, socketsOutput, socketName);
		}
	}
	initAddintionalLabel() {
		const label = $div("additional-label");
		label.textContent = this.socketsOutput.optionalInfo.additionalLabel;
		this.domElement().prepend(label);
	}
	// Hover functionality now handled by SolidJS HoverFeatureMenu
	loadAsync() {
		const input = document.createElement("textarea");
		this.dom.content = input;
		this.dom.content.addEventListener("keydown", (e) => {
			this.recalculateTextAreaHeight();
			e.stopPropagation();
		});
		this.dom.content.addEventListener("paste", (e) => {
			e.stopPropagation();
		});
		this.dom.content.value = this.asset.value;

		this.dom.content.style.width = "100%";

		const handleMouseMove = (e) => {
			e.stopPropagation();
		};
		input.addEventListener("mousedown", (e) => {
			e.stopPropagation();
			Editor.context.graph.handleNodeSelection(this.socketsOutput.node, e);
		});
		input.addEventListener("mousemove", handleMouseMove);
		input.addEventListener("dragstart", (e) => {
			e.stopPropagation();
			e.preventDefault();
		});
		input.addEventListener("change", (e) => {
			if (this.socketsOutput) {
				this.socketsOutput.value = e.target.value;
			}
			this.valueHasBeenChanged();
		});
		this.domElement().append(this.dom.content);
		onNextFrame(() => this.recalculateTextAreaHeight());
	}
	valueHasBeenChanged() {
		this.socketsOutput.fireChange();
	}
	getInputValue() {
		return this.dom.content.value;
	}
	reloadAssetAsync(asset) {
		this.asset = asset;
		this.dom.content.value = this.asset.value;

		onNextFrame(() => {
			this.recalculateTextAreaHeight();
		});
	}
	recalculateTextAreaHeight() {
		recalculateTextAreaHeight(this.dom.content);
	}
	/**
	 * @param {()=>void=} callback
	 */
	addOutputListener(callback) {
		this.callback = callback
			? callback
			: (e) => {
					this.asset.value = e.target.value;
				};
		this.dom.content.removeEventListener("keyup", this.callback);
		this.dom.content.addEventListener("keyup", this.callback);
	}
}
